export default {
    cnsInternacao: null,
    errorCns: null,
    listaProcedimentos: new Array(),
    listaCid: new Array(),
    consolidado: new Array()
}
